import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=8547bdc0"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8547bdc0')) {
      api.createRecord('8547bdc0', component.options)
    } else {
      api.reload('8547bdc0', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=8547bdc0", function () {
      api.rerender('8547bdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizardUser/Payment.vue"
export default component.exports